import store from '../Store/index'

export const getToken = () => {
  const { user } = store.getState()
    
  return user.token
  //return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwdWJsaWNfaWQiOjc1MX0.MpRsSvu_K35BhgZNI81piv35rM3nh_nEvbDqh0YxHgI'
}